import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import Cropper from 'cropperjs';

declare var GGBApplet: any;
@Component({
  selector: 'app-enovsky-draw-modal',
  templateUrl: './enovsky-draw-modal.component.html',
  styleUrls: ['./enovsky-draw-modal.component.scss']
})
export class EnovskyDrawModalComponent implements AfterViewInit{
  constructor(
    public dialogRef: MatDialogRef<EnovskyDrawModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    private apiService: ApiServiceModule,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
  ) {}
  @ViewChild('ggbContainer', { static: false }) ggbContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('ketcherFrame', { static: false }) ketcherFrame!: ElementRef<HTMLIFrameElement>;
  @ViewChild('imageCropper', { static: false }) imageCropper!: ElementRef<HTMLImageElement>;
  cropper!: Cropper;
  cropType:string = 'rectangle';
  appNameControl = new FormControl();
  sourceModal:string = this.data['source'];

  appName = 'graphing';
  inProgress = false;
  applet: any;
  ggbApi: any;
  container: any = null;
  async ngOnInit() {
    if(this.sourceModal == 'geogebra'){
      const structure = this.data['structure'];
      if (structure) {
        const detectedApp = this.getGeoGebraApp(structure);
        if (detectedApp) {
          this.appName = detectedApp;
        }
      }
      this.appNameControl.setValue(this.appName);
    }
    
  }
  async ngAfterViewInit() {
    if(this.sourceModal == 'geogebra'){
      this.container = this.ggbContainer.nativeElement;
      this.loadApplet(this.appName);
    }
    const structure = this.data['structure'];
    if (structure) {
      let structureData = JSON.parse(structure);
      const win = this.ketcherFrame.nativeElement.contentWindow as any;

      const ketcherPromise = await this.waitForKetcher(win);
      const ketcher = await ketcherPromise;
      await ketcher.setMolecule(structureData);
    }
    if(this.sourceModal == 'crop_image'){
      this.cropper = new Cropper(this.imageCropper.nativeElement, {
        container: this.imageCropper.nativeElement.parentElement!
      });
      // 🔥 IMPORTANT: create selection manually
      const selection = document.createElement('cropper-selection');
      selection.setAttribute('movable', '');
      selection.setAttribute('resizable', '');

      const canvas = this.imageCropper.nativeElement.parentElement!.querySelector('cropper-canvas');

      canvas?.appendChild(selection);
    }
    
  }
  setCropType(cropType:string) {
    this.cropType = cropType;
  }

  waitForKetcher(win: any): Promise<any> {
    return new Promise((resolve) => {
      const check = () => {
        if (win.ketcher) {
          resolve(win.ketcher);
        } else {
          requestAnimationFrame(check);
        }
      };
      check();
    });
  }
  loadApplet(appName: string) {
    this.container.replaceChildren();
    const params = {
      appName: appName,
      width: this.container.offsetWidth,
      height: this.container.offsetHeight,
      showToolBar: true,
      showAlgebraInput: true,
      showMenuBar: true,
      showZoomButtons: true,
      showResetIcon: true,
      enableRightClick: true,
      enableShiftDragZoom: true,

      appletOnLoad: (api: any) => {
        this.ggbApi = api;
        if(this.data['structure']){
          if(this.sourceModal == 'geogebra') this.ggbApi.setXML(this.data['structure']);
        }
        api.setGridVisible(true);
        api.setAxesVisible(true, true);
      }
    };

    this.applet = new GGBApplet(params, true);
    this.applet.inject(this.container);
  }
  switchApplication(){
    this.appName = this.appNameControl.value;
    this.loadApplet(this.appName);
  }
  async onKetcherLoad(){
    
  }
  async exportSVG() {
    if(this.sourceModal == 'geogebra'){
        if (!this.ggbApi) {
        console.error('GeoGebra not ready');
        return;
      }
      if (typeof this.ggbApi.exportSVG !== 'function') {
        console.error('SVG export not supported');
        return;
      }
      if(this.appName != '3d') this.ggbApi.exportSVG(async(svg: string) => {
        let blobUrl:any = await this.svgToBase64(svg);
        let {width, height} = this.getSvgSizes(svg);
        const xml = this.ggbApi.getXML();
        this.dialogRef.close({status: true, structure: xml, image: blobUrl, width: width, height: height});
      });
      if(this.appName == '3d'){
        let png = await this.ggbApi.getPNGBase64(1, false, 300);
        const canvas = this.container.querySelector('canvas');
        const width = canvas?.width ?? 50;
        const height = canvas?.height ?? 50;
        
        if (!png.startsWith("data:image")) {
          png = "data:image/png;base64," + png;
        }
        const xml = this.ggbApi.getXML();
        this.dialogRef.close({status: true, structure: xml, image: png, width: width, height: height});
      }
    }
    if(this.sourceModal == 'chemistry'){
      const win = this.ketcherFrame.nativeElement.contentWindow as any;
      const ketcher = await win.ketcher;
      const struct = await ketcher.getKet();
      let divCanvas = win.document.querySelector('.StructEditor-module_intermediateCanvas__fR3ws')

      const svgElement = divCanvas.querySelector('svg') as SVGSVGElement | null;
      const svg = this.cropKetcherSvg(svgElement!);

      /* VERSION PREBUILD
      let options = {outputFormat: 'svg'}
      const imgBlob = await ketcher.generateImage(struct, options);
      console.log(imgBlob)
      const svg = await imgBlob.text(); */
      let blobUrl:any = await this.svgToBase64(svg);
      let {width, height} = this.getSvgSizes(svg);
      this.dialogRef.close({status: true, structure: JSON.stringify(struct), image: blobUrl, width: width, height: height});
    }
    if(this.sourceModal == 'crop_image'){
      const selection = this.cropper.getCropperSelection();
      if (!selection) return;
      const cropped = await selection.$toCanvas();
      
      if(this.data.image.startsWith('data:image/svg+xml')){
        const selectionEl = this.imageCropper.nativeElement.parentElement!.querySelector('cropper-selection') as HTMLElement;

        const canvasEl = this.imageCropper.nativeElement.parentElement!.querySelector('cropper-canvas') as HTMLElement;

        const imageEl = canvasEl.querySelector('cropper-image') as HTMLElement;

        if (!selectionEl || !canvasEl || !imageEl) return;

        const canvasRect = canvasEl.getBoundingClientRect();
        const selRect = selectionEl.getBoundingClientRect();
        const imageRect = imageEl.getBoundingClientRect();

        // Decode SVG
        const svgText = atob(this.data.image.split(',')[1]);
        const parser = new DOMParser();
        const doc = parser.parseFromString(svgText, 'image/svg+xml');
        const svg = doc.querySelector('svg');

        if (svg) {
          const svgWidth = parseFloat(svg.getAttribute('width') || '100');
          const svgHeight = parseFloat(svg.getAttribute('height') || '100');

          // Selection relative to canvas
          const selXCanvas = selRect.left - canvasRect.left;
          const selYCanvas = selRect.top - canvasRect.top;

          // Image relative to canvas
          const imgXCanvas = imageRect.left - canvasRect.left;
          const imgYCanvas = imageRect.top - canvasRect.top;

          // Selection relative to IMAGE
          const selXImage = selXCanvas - imgXCanvas;
          const selYImage = selYCanvas - imgYCanvas;

          const selWidth = selRect.width;
          const selHeight = selRect.height;

          // Scale using displayed image size
          const displayedWidth = imageRect.width;
          const displayedHeight = imageRect.height;

          const scaleX = svgWidth / displayedWidth;
          const scaleY = svgHeight / displayedHeight;

          const cropX = selXImage * scaleX;
          const cropY = selYImage * scaleY;
          const cropWidth = selWidth * scaleX;
          const cropHeight = selHeight * scaleY;

          console.log(`${cropX} ${cropY} ${cropWidth} ${cropHeight}`);

          svg.setAttribute('viewBox', `${cropX} ${cropY} ${cropWidth} ${cropHeight}`);
          svg.setAttribute('width', `${cropWidth}`);
          svg.setAttribute('height', `${cropHeight}`);

          const croppedSvgText = new XMLSerializer().serializeToString(svg);
          const blobUrl: any = await this.svgToBase64(croppedSvgText);

          console.log(blobUrl)
                  this.dialogRef.close({status: true, image: blobUrl, width: cropWidth, height: cropHeight});
        }
      }else{
        
        let canvas = null;
        if(this.cropType == 'rectangle') canvas = cropped;
        if(this.cropType == 'ellipse'){
          canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d')!;
          canvas.width = cropped.width;
          canvas.height = cropped.height;
          ctx.beginPath();
          ctx.ellipse(cropped.width / 2, cropped.height / 2, cropped.width / 2, cropped.height / 2, 0, 0, Math.PI * 2);
          ctx.clip();
          ctx.drawImage(cropped, 0, 0);
        }
        const base64 = canvas!.toDataURL('image/png');
        this.dialogRef.close({status: true, image: base64, width: canvas!.width, height: canvas!.height});
      }
    }
  }
  svgToBase64(svg:any) {
    const blob = new Blob([svg], { type: "image/svg+xml" });
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
  getSvgSizes(svg: string){
    const parser = new DOMParser();
    const doc = parser.parseFromString(svg, "image/svg+xml");
    const el = doc.documentElement;
    let width = parseFloat(el.getAttribute("width") || "50");
    let height = parseFloat(el.getAttribute("height") || "50");

    if (!width || !height) {
      const viewBox = el.getAttribute("viewBox");
      if (viewBox) {
        const [, , w, h] = viewBox.split(" ").map(Number);
        width = w;
        height = h;
      }
    }
    return {width, height};
  }
  getGeoGebraApp(xml: string): string | null {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, "text/xml");

    const root = doc.documentElement; // <geogebra>
    return root.getAttribute("app");
  }
  onClose(){
    this.dialogRef.close({status: false});
  }
  cropKetcherSvg(svgElement: SVGSVGElement, padding = 1): string {
    const clone = svgElement.cloneNode(true) as SVGSVGElement;

    const elements = Array.from(
      svgElement.querySelectorAll(
        'path, line, polyline, polygon, circle, ellipse, rect, text'
      )
    ) as SVGGraphicsElement[];

    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    for (const element of elements) {
      // Ignore invisible elements
      const style = window.getComputedStyle(element);

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        parseFloat(style.opacity || '1') === 0
      ) {
        continue;
      }

      try {
        const box = element.getBBox();

        if (box.width === 0 && box.height === 0) continue;

        minX = Math.min(minX, box.x);
        minY = Math.min(minY, box.y);
        maxX = Math.max(maxX, box.x + box.width);
        maxY = Math.max(maxY, box.y + box.height);
      } catch {
        // Ignore elements without a valid bounding box
      }
    }

    if (!isFinite(minX)) {
      throw new Error('No visible SVG content found');
    }

    const x = minX - padding;
    const y = minY - padding;
    const width = maxX - minX + padding * 2;
    const height = maxY - minY + padding * 2;

    clone.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);
    clone.setAttribute('width', `${width}`);
    clone.setAttribute('height', `${height}`);

    return clone.outerHTML;
  }
}